<template>
  <div id="app">
    <div v-bind:class="['main-container', showMenu ? 'block' : 'non-block']">
      <header-component></header-component>
      <router-view />
      <footer-component></footer-component>
      <notification></notification>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import Notification from "@/components/notification/Notification.vue";

export default {
  name: "App",
  components: {
    footerComponent: Footer,
    headerComponent: Header,
    Notification: Notification
  },
  computed: {
    ...mapGetters({
      showMenu: 'showMenu'
    })
  },
};
</script>

<style>
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  src: url("~@/assets/fonts/Roboto-Regular.eot");
  /* IE9 Compat Modes */
  src: local("Roboto"), local("Roboto-Regular"),
    url("~@/assets/fonts/Roboto-Regular.eot#iefix") format("embedded-opentype"),
    url("~@/assets/fonts/Roboto-Regular.woff2") format("woff2"),
    url("~@/assets/fonts/Roboto-Regular.woff") format("woff"),
    url("~@/assets/fonts/Roboto-Regular.ttf") format("truetype"),
    url("~@/assets/fonts/Roboto-Regular.svg#Roboto") format("svg");
  /* Legacy iOS */
}

@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  src: url("~@/assets/fonts/Roboto-Bold.eot");
  /* IE9 Compat Modes */
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url("~@/assets/fonts/Roboto-Bold.eot#iefix") format("embedded-opentype"),
    url("~@/assets/fonts/Roboto-Bold.woff2") format("woff2"),
    url("~@/assets/fonts/Roboto-Bold.woff") format("woff"),
    url("~@/assets/fonts/Roboto-Bold.ttf") format("truetype"),
    url("~@/assets/fonts/Roboto-Bold.svg#Roboto") format("svg");
  /* Legacy iOS */
}

@font-face {
  font-family: "streamline-icons";
  font-style: normal;
  font-weight: 700;
  src: url("~@/assets/fonts/streamline-icons-glyph.eot");
  src: url("~@/assets/fonts/streamline-icons-glyph.eot")
      format("embedded-opentype"),
    url("~@/assets/fonts/streamline-icons-glyph.woff2") format("woff2"),
    url("~@/assets/fonts/streamline-icons-glyph.woff") format("woff"),
    url("~@/assets/fonts/streamline-icons-glyph.ttf") format("truetype"),
    url("~@/assets/fonts/streamline-icons-glyph.svg") format("svg");
}

@font-face {
  font-family: "streamline-icons";
  font-style: normal;
  font-weight: 600;
  src: url("~@/assets/fonts/streamline-icons-bold.eot");
  src: url("~@/assets/fonts/streamline-icons-bold.eot")
      format("embedded-opentype"),
    url("~@/assets/fonts/streamline-icons-bold.woff2") format("woff2"),
    url("~@/assets/fonts/streamline-icons-bold.woff") format("woff"),
    url("~@/assets/fonts/streamline-icons-bold.ttf") format("truetype"),
    url("~@/assets/fonts/streamline-icons-bold.svg") format("svg");
}

@font-face {
  font-family: "streamline-icons";
  font-style: normal;
  font-weight: 300;
  src: url("~@/assets/fonts/streamline-icons-regular.eot");
  src: url("~@/assets/fonts/streamline-icons-regular.eot")
      format("embedded-opentype"),
    url("~@/assets/fonts/streamline-icons-regular.woff2") format("woff2"),
    url("~@/assets/fonts/streamline-icons-regular.woff") format("woff"),
    url("~@/assets/fonts/streamline-icons-regular.ttf") format("truetype"),
    url("~@/assets/fonts/streamline-icons-regular.svg") format("svg");
}
</style>